import { MAD } from '../../../../index';
import { NCustomAsset, NProgram } from '../../../dataStore/types';

export const anthemFetchOptions = (
  method: 'GET' | 'POST' | 'PUT' | 'DELETE',
  workgroupId?: number,
  body?: object
): RequestInit => {
  var headers: { [key: string]: string } = {
    'Content-Type': body ? 'application/json' : '',
    'x-harmony-impersonated-workgroupId': workgroupId ? workgroupId.toString() : '',
  };

  var token = process.env.REACT_APP_TOKEN;
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return {
    method,
    credentials: 'include',
    headers: headers,
    body: JSON.stringify(body),
  };
};

export const anthemApi = {
  anthemGetAllPrograms: async (
    companyId: number,
    licensingEntityId: number
  ): Promise<NProgram[]> => {
    const result = await fetch(
      `${process.env.REACT_APP_ROOT_DOMAIN}music/api/program/all/${licensingEntityId}`,
      anthemFetchOptions('GET', companyId)
    );
    return result.json();
  },

  anthemGetCustomAssets: async (
    workgroupId: number,
    licensingEntityId: number
  ): Promise<NCustomAsset[]> => {
    const result = await fetch(
      `${process.env.REACT_APP_ROOT_DOMAIN}music/api/program/custom?licensingEntityId=${licensingEntityId}`,
      anthemFetchOptions('GET')
    );
    return result.json();
  },

  anthemSaveCustomAssetToCompany: async (
    workgroupId: number,
    addedItems: NCustomAsset[],
    removedItems: NCustomAsset[]
  ): Promise<any> => {
    const result = await fetch(
      `${process.env.REACT_APP_ROOT_DOMAIN}music/api/music/customAssetWorkgroup`,
      anthemFetchOptions('POST', workgroupId, {
        addedAssets: addedItems.map((x) => ({
          assetId: x.id,
          companyId: workgroupId,
          assetTypeId: 2,
        })),
        removedAssets: removedItems.map((x) => ({
          assetId: x.id,
          companyId: workgroupId,
          assetTypeId: 2,
        })),
      })
    );
    return result.json();
  },

  anthemGetMediaLibrary: async (
    workgroupId: number
  ): Promise<Array<{ programId: number; assetId: number }>> => {
    const result = await fetch(
      `${process.env.REACT_APP_ROOT_DOMAIN}music/api/library/programs/${workgroupId}`,
      anthemFetchOptions('GET', workgroupId)
    );
    return result.json();
  },
  assignStationToDevice: async (
    playerId: number,
    stationId: number,
    serial: string,
    channelId: number,
    workgroupId: number
  ): Promise<void> => {
    const result = await fetch(
      `${process.env.REACT_APP_ROOT_DOMAIN}music/api/device/station`,
      anthemFetchOptions('PUT', workgroupId, {
        playerId,
        stationId,
        serial,
        channelId,
      })
    );

    if (!result.ok) {
      throw new Error('Could not assign station to device');
    }
  },
};
